export const getCurrency = (amount: number = 0) => {
	const currency = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		currencyDisplay: 'narrowSymbol',
	}).format(amount);

	return currency;
};
